// src/plugins/toast/composables/useToast.js
import { useToast as _useToast } from 'vue-toastification'

export function useToast(options) {
  return _useToast(options)
}
